import { TreeNodeDTO } from 'business/models/Models';
import ETreeActionTypes from 'enums/ETreeActionTypes';
import React from 'react';

interface Props {
  nodesToCopy: TreeNodeDTO[];
  unableToPasteNodes: { node: TreeNodeDTO; reason: string }[];
  targetNode: TreeNodeDTO;
  actionType: ETreeActionTypes;
}

const PasteModalConfirmationBody = (props: Props) => {
  const { nodesToCopy, unableToPasteNodes, targetNode, actionType } = props;
  return (
    <>
      {nodesToCopy.length > 0 && (
        <div id='explorer-pastemodalconfirmationbody-message'>
          Are you sure you want to{' '}
          {actionType === ETreeActionTypes.Cut ? 'move' : 'copy'} these files to{' '}
          {targetNode.name}?
          <br />
          {nodesToCopy.map((node, index) => (
            <div id={`explorer-pastemodalconfirmationbody-node-${index}`}
              className="ml-4" key={index}>{`${index + 1}) ${node.name}`}</div>
          ))}
        </div>
      )}
      {unableToPasteNodes.length > 0 && (
        <div  id="explorer-pastemodalconfirmationbody-unablelist">
          These files cannot be pasted, hover to see details
          {unableToPasteNodes.map((nodeResponse, index) => (
            <div id={`explorer-pastemodalconfirmationbody-unable-${index}`}
              className="text-red-800 ml-4"
              key={index}
              title={nodeResponse.reason}
            >{`${index + 1}) ${nodeResponse.node.name}`}</div>
          ))}
        </div>
      )}
    </>
  );
};

export default PasteModalConfirmationBody;
